<div class="route-map-container">
  <div #mapContainer class="map-container"></div>
</div>
